"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.0013 20.6087C16.7557 20.6087 20.61 16.7544 20.61 12C20.61 7.24554 16.7557 3.3913 12.0013 3.3913C7.24682 3.3913 3.39258 7.24554 3.39258 12C3.39258 16.7544 7.24682 20.6087 12.0013 20.6087Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 15.6348C14.0075 15.6348 15.6348 14.0074 15.6348 12C15.6348 9.99255 14.0075 8.3652 12 8.3652C9.99258 8.3652 8.36523 9.99255 8.36523 12C8.36523 14.0074 9.99258 15.6348 12 15.6348Z",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M3.10435 14.1043C4.26655 14.1043 5.2087 13.1622 5.2087 12C5.2087 10.8378 4.26655 9.89565 3.10435 9.89565C1.94215 9.89565 1 10.8378 1 12C1 13.1622 1.94215 14.1043 3.10435 14.1043Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.0008 5.2087C13.163 5.2087 14.1052 4.26655 14.1052 3.10435C14.1052 1.94215 13.163 1 12.0008 1C10.8386 1 9.89648 1.94215 9.89648 3.10435C9.89648 4.26655 10.8386 5.2087 12.0008 5.2087Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.0008 23C13.163 23 14.1052 22.0579 14.1052 20.8957C14.1052 19.7335 13.163 18.7913 12.0008 18.7913C10.8386 18.7913 9.89648 19.7335 9.89648 20.8957C9.89648 22.0579 10.8386 23 12.0008 23Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M20.8954 14.1043C22.0576 14.1043 22.9997 13.1622 22.9997 12C22.9997 10.8378 22.0576 9.89565 20.8954 9.89565C19.7332 9.89565 18.791 10.8378 18.791 12C18.791 13.1622 19.7332 14.1043 20.8954 14.1043Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeMiterlimit: "10"
  })]
}));